import {
  type GraphPath,
  createTopologyGraphLink,
  formatUptimeCellValue,
} from '@ipfabric/utils';
import { type FC, memo } from 'react';

import { Link } from 'react-router-dom';
import type { AppTranslations } from 'translations/translations';

export type DeviceDetailData = {
  configReg: string | null;
  family: string | null;
  hostname: string | null;
  id?: string | null;
  image: string | null;
  loginIpv4: string | null;
  loginIpv6: string | null;
  loginType: string | null;
  loginPort: number | null;
  memoryUtilization: number | null;
  model: string | null;
  platform: string | null;
  processor: string | null;
  rd: string | null;
  reload: string | null;
  siteName: string | null;
  slug: string | null;
  sn: string | null;
  stpDomain: string | null;
  taskKey: string | null;
  uptime: number | null;
  vendor: string | null;
  version: string | null;
};

interface Props {
  disableRdLink?: boolean;
  disableSiteLink?: boolean;
  disableStpLink?: boolean;
  firstColumnClassName?: string;
  msg: AppTranslations['hostnameTableDetail']['table'];
  secondColumnClassName?: string;
  tableClassName?: string;
  tableData: DeviceDetailData;
}

const BareHostnameDetailContent: FC<Props> = (props) => {
  return (
    <table className={props.tableClassName}>
      <tbody>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.hostname}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.hostname}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.siteName}</td>
          <td className={props.secondColumnClassName}>
            {props.disableSiteLink || props.tableData.siteName === null ? (
              props.tableData.siteName
            ) : (
              <Link
                {...createTopologyGraphLink({
                  parameters: {
                    paths: [props.tableData.siteName as GraphPath],
                    groupBy: 'siteName',
                  },
                })}
              >
                {props.tableData.siteName}
              </Link>
            )}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.rd}</td>
          <td className={props.secondColumnClassName}>
            {props.disableRdLink || props.tableData.rd === null ? (
              props.tableData.rd
            ) : (
              <Link
                {...createTopologyGraphLink({
                  parameters: {
                    paths: [props.tableData.rd as GraphPath],
                    groupBy: 'routingDomain',
                  },
                })}
              >
                {props.tableData.rd}
              </Link>
            )}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.stpDomain}</td>
          <td className={props.secondColumnClassName}>
            {props.disableStpLink || props.tableData.stpDomain === null ? (
              props.tableData.stpDomain
            ) : (
              <Link
                {...createTopologyGraphLink({
                  parameters: {
                    paths: [props.tableData.stpDomain as GraphPath],
                    groupBy: 'stpDomain',
                  },
                })}
              >
                {props.tableData.stpDomain}
              </Link>
            )}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>
            {props.msg.vendorFamily}
          </td>
          <td className={props.secondColumnClassName}>
            {props.tableData.vendor} {props.tableData.family}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.platform}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.platform}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.model}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.model}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.version}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.version}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.processor}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.processor}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.sn}</td>
          <td className={props.secondColumnClassName}>{props.tableData.sn}</td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.loginIp}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.loginIpv4 || props.tableData.loginIpv6}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.loginType}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.loginType}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.uptime}</td>
          <td className={props.secondColumnClassName}>
            {formatUptimeCellValue(props.tableData.uptime)}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.image}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.image}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.reload}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.reload}
          </td>
        </tr>

        <tr>
          <td className={props.firstColumnClassName}>{props.msg.configReg}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.configReg}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>
            {props.msg.memoryUtilization}
          </td>
          <td className={props.secondColumnClassName}>
            {props.tableData.memoryUtilization}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>{props.msg.slug}</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.slug}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export const HostnameDetailContent = memo(BareHostnameDetailContent);
